module.exports = __webpack_public_path__ + "static/Thomas Dykstra.e9f84114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Thomas Dykstra.jpg
// module id = 1241
// module chunks = 6166952557895